<mat-form-field class="angular-calendar-wrapper">
  <input
    matInput
    [attr.aria-label]="'datePicker'"
    [matDatepicker]="picker"
    [matDatepickerFilter]="availableFilter"
    [value]="date.value"
    (dateChange)="onDateSelected($event)" />

  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker (closed)="onClose()" touchUi #picker></mat-datepicker>
</mat-form-field>

<button
  mat-flat-button
  class="only-icon"
  appStopPropagation
  (click)="picker.open()"
  [opacTooltip]="'tooltip.pastIssueDates' | translate"
  [attr.aria-label]="'tooltip.pastIssueDates' | translate">
  <span class="odilo-icon" aria-hidden="true">calendar</span>
</button>
